import { includesPermission, Permission, useAdminPermissions } from '@infl-ts/util-use-admin-permissions';
import { constFalse, constTrue, flow, identity, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as L from 'monocle-ts/Lens';
import { mapAllBlocks, MODIFICATION_ID } from './map-block';
var forceHashChange = pipe(L.id(), L.prop('hash'), L.modify(function (hash) {
  return "".concat(hash, "-").concat(MODIFICATION_ID);
}));
var disableMessaging = pipe(L.id(), L.prop('messagingEnabled'), L.modify(constFalse));

var disableBlockMessaging = function disableBlockMessaging(block) {
  return ['NavBlock', 'ProfilePageBlock', 'ChatPageBlock'].includes(block.__typename) ? pipe(block, forceHashChange, disableMessaging) : block;
};

var disableConfigMessaging = pipe(L.id(), L.prop('configs'), L.prop('popoverConfig'), L.modify(O.map(function (config) {
  return disableMessaging(config);
})));
export var createAdminConfig = function createAdminConfig(permissions) {
  return pipe(permissions, O.match(constTrue, includesPermission(Permission.map.MemberInteractionsAccess)), function (hasMemberInteractionAccess) {
    return hasMemberInteractionAccess ? identity : flow(mapAllBlocks(disableBlockMessaging), disableConfigMessaging);
  });
};
export var useAdminSiteConfig = flow(useAdminPermissions, createAdminConfig);